import { render, staticRenderFns } from "./InventoryShelfDay.vue?vue&type=template&id=3d4bcb15&scoped=true&"
import script from "./InventoryShelfDay.vue?vue&type=script&lang=js&"
export * from "./InventoryShelfDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bcb15",
  null
  
)

export default component.exports